<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="
        bg-primary 
        text-white 
        border-0 
        font-weight-bold 
        p-3 
        d-flex 
        align-items-center
      ">Pembayaran  {{ this.title_tab }}
    </CCardHeader>
    
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/keuangan/pembayaran/sertifikasi-reguler"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="mountedchange('/keuangan/pembayaran/sertifikasi-reguler')"
          aria-controls="home"
          aria-selected="true">Sertifikasi Reguler</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keuangan/pembayaran/sertifikasi-rpl"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="webinar-tab"
          data-toggle="tab"
          href="#webiner"
          role="tab"
          @click.native="mountedchange('/keuangan/pembayaran/sertifikasi-rpl')"
          aria-controls="home"
          aria-selected="false">Sertifikasi RPL</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/keuangan/pembayaran/pelatihan"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="mountedchange('/keuangan/pembayaran/pelatihan')"
          aria-controls="profile"
          aria-selected="false"> Pelatihan</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keuangan/pembayaran/iuran-keanggotaan"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="mountedchange('/keuangan/pembayaran/iuran-keanggotaan')"
          aria-controls="profile"
          aria-selected="false">Iuran Keanggotaan</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keuangan/pembayaran/outstanding"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="mountedchange('/keuangan/pembayaran/outstanding')"
          aria-controls="profile"
          aria-selected="false">Outstanding Iuran</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keuangan/pembayaran/pengajuan-refund"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="mountedchange('/keuangan/pembayaran/pengajuan-refund')"
          aria-controls="profile"
          aria-selected="false">Pengajuan Refund</router-link>
      </li>
    </ul>

    <!-- Data RPL-->
    <router-view></router-view>
    <!-- End Data RPL -->
  </CCard>
</template>

<script>
export default {
  name: "Master Sertifikasi RPL",
  data() {
    return {
        title_tab : 'Sertifikasi Reguler',
    };
  },
  mounted() {
    this.mountedchange(this.$router.currentRoute.path)
  },
  methods: {
    mountedchange(value) {
      switch (value) {
          case '/keuangan/pembayaran/sertifikasi-reguler':
              this.title_tab = 'Sertifikasi Reguler';
              break;
          case '/keuangan/pembayaran/sertifikasi-rpl':
              this.title_tab = 'Sertifikasi RPL';
              break;
          case '/keuangan/pembayaran/pelatihan':
              this.title_tab = 'Pelatihan';
              break;
          case '/keuangan/pembayaran/iuran-keanggotaan':
              this.title_tab = 'Iuran Keanggotaan';
              break;
          case '/keuangan/pembayaran/outstanding':
              this.title_tab = 'Outstanding Iuran';
              break;
          case '/keuangan/pembayaran/pengajuan-refund':
              this.title_tab = 'Pengajuan Refund';
              break;
          default:
              break;
      }
    }
  }
};
</script>